import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import { get_company_list as _get_company_list } from "../../services/CI/CI1001S";
import { create_link as _create_link, create_link_batch as _create_link_batch, delete_link as _delete_link, get_agency_list as _get_agency_list, get_device_list as _get_device_list, get_link_list as _get_link_list, get_link_stat as _get_link_stat, get_speed_rule as _get_speed_rule, update_link as _update_link, set_backup_link as _set_backup_link, update_link_batch as _update_link_batch, get_l3_tunnel as _get_l3_tunnel, create_l3_tunnel as _create_l3_tunnel, update_l3_tunnel as _update_l3_tunnel, delete_l3_tunnel as _delete_l3_tunnel, get_ip_groups as _get_ip_groups, get_deleted_link as _get_deleted_link, all_company_update, get_link_interface_ip as _get_link_interface_ip, query_link_effect as _query_link_effect } from "../../services/Company/companyS";
import _ from "lodash";
import { BossMessage } from "../../components/Common/BossMessages";
export default {
  namespace: "bi1101Info",
  state: {
    companyList: [],
    agencyListCenter: [],
    agencyListEdge: [],
    agencyListCenterBatch: [],
    agencyListEdgeBatch: [],
    deviceList: [],
    typeList: ['国内组网', '全球组网', '全球SaaS加速'],
    linkList: [],
    linkStat: [],
    total: 0,
    HALinkList: [],
    l3TunnelData: [],
    ipGroupData: [],
    initPayload: {}
  },
  effects: {
    get_link_list: function get_link_list(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return call(_get_link_list, payload);
            case 2:
              backData = _context.sent;
              _context.next = 5;
              return put({
                type: "update",
                payload: {
                  linkList: backData.result && Array.isArray(backData.result) ? backData.result : [],
                  total: backData.total,
                  initPayload: payload
                }
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    get_deleted_link: function get_deleted_link(_ref3, _ref4) {
      var payload = _ref3.payload;
      var call = _ref4.call,
        put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(_get_deleted_link, payload);
            case 2:
              backData = _context2.sent;
              _context2.next = 5;
              return put({
                type: "update",
                payload: {
                  linkList: backData && backData.result && Array.isArray(backData.result) ? backData.result : [],
                  total: backData.total
                }
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    },
    get_link_stat: function get_link_stat(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call,
        put = _ref6.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var backData, total;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(_get_link_stat, _objectSpread({}, payload, {
                is_active: 1
              }));
            case 2:
              backData = _context3.sent;
              total = _.get(backData, 'INIT', 0) + _.get(backData, 'ONLINE', 0) + _.get(backData, 'OFFLINE', 0);
              _context3.next = 6;
              return put({
                type: 'update',
                payload: {
                  linkStat: backData // total: total
                }
              });
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })();
    },
    get_agency_list: function get_agency_list(_ref7, _ref8) {
      var payload = _ref7.payload;
      var call = _ref8.call,
        put = _ref8.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(payload.company_name !== 'SaaS' && !payload.company_id && payload.company_name !== 'SaaS_New')) {
                _context4.next = 5;
                break;
              }
              _context4.next = 3;
              return put({
                type: "update",
                payload: {
                  agencyListCenter: []
                }
              });
            case 3:
              _context4.next = 16;
              break;
            case 5:
              _context4.next = 7;
              return call(_get_agency_list, payload);
            case 7:
              backData = _context4.sent;
              if (!backData.result) {
                _context4.next = 16;
                break;
              }
              if (!(payload.type === "CSTEP" || payload.company_name == 'SaaS' || payload.company_name == 'SaaS_New')) {
                _context4.next = 14;
                break;
              }
              _context4.next = 12;
              return put({
                type: "update",
                payload: {
                  agencyListCenter: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 12:
              _context4.next = 16;
              break;
            case 14:
              _context4.next = 16;
              return put({
                type: "update",
                payload: {
                  agencyListEdge: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })();
    },
    get_agency_list_batch: function get_agency_list_batch(_ref9, _ref10) {
      var payload = _ref9.payload;
      var call = _ref10.call,
        put = _ref10.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(_get_agency_list, payload);
            case 2:
              backData = _context5.sent;
              if (!backData.result) {
                _context5.next = 11;
                break;
              }
              if (!(payload.type === "CSTEP")) {
                _context5.next = 9;
                break;
              }
              _context5.next = 7;
              return put({
                type: "update",
                payload: {
                  agencyListCenterBatch: backData && backData.result && Array.isArray(backData.result) ? backData.result : [] // agencyListEdgeBatch:[]
                }
              });
            case 7:
              _context5.next = 11;
              break;
            case 9:
              _context5.next = 11;
              return put({
                type: "update",
                payload: {
                  agencyListEdgeBatch: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })();
    },
    get_company_list: function get_company_list(_ref11, _ref12) {
      var payload = _ref11.payload;
      var call = _ref12.call,
        put = _ref12.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return call(_get_company_list, payload);
            case 2:
              backData = _context6.sent;
              if (!backData.result) {
                _context6.next = 6;
                break;
              }
              _context6.next = 6;
              return put({
                type: "update",
                payload: {
                  companyList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })();
    },
    get_device_list: function get_device_list(_ref13, _ref14) {
      var payload = _ref13.payload;
      var call = _ref14.call,
        put = _ref14.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return call(_get_device_list, payload);
            case 2:
              backData = _context7.sent;
              _context7.next = 5;
              return put({
                type: "update",
                payload: {
                  deviceList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })();
    },
    reset_device_list: function reset_device_list(_ref15, _ref16) {
      var payload = _ref15.payload;
      var put = _ref16.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return put({
                type: "update",
                payload: {
                  deviceList: []
                }
              });
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })();
    },
    get_speed_rule: function get_speed_rule(_ref17, _ref18) {
      var payload = _ref17.payload;
      var call = _ref18.call,
        put = _ref18.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return call(_get_speed_rule, payload);
            case 2:
              backData = _context9.sent;
              _context9.next = 5;
              return put({
                type: "update",
                payload: {
                  typeList: backData.options
                }
              });
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      })();
    },
    create_link: function create_link(_ref19, _ref20) {
      var payload = _ref19.payload;
      var select = _ref20.select,
        call = _ref20.call,
        put = _ref20.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var backData, initPayload;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return call(_create_link, payload.update);
            case 2:
              backData = _context10.sent;
              _context10.next = 5;
              return select(function (state) {
                return state.bi1101Info.initPayload;
              });
            case 5:
              initPayload = _context10.sent;
              if (!backData.success) {
                _context10.next = 16;
                break;
              }
              BossMessage(true, "Successfully added");
              _context10.next = 10;
              return call(all_company_update, {
                company_id: payload.update.company_id
              });
            case 10:
              _context10.next = 12;
              return put({
                type: "get_link_list",
                payload: initPayload
              });
            case 12:
              _context10.next = 14;
              return put({
                type: "get_link_stat",
                payload: {
                  is_active: 1
                }
              });
            case 14:
              _context10.next = 17;
              break;
            case 16:
              BossMessage(false, "Add failed:" + backData.result);
            case 17:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      })();
    },
    update_link: function update_link(_ref21, _ref22) {
      var payload = _ref21.payload;
      var select = _ref22.select,
        call = _ref22.call,
        put = _ref22.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var backData, initPayload;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return call(_update_link, payload.update);
            case 2:
              backData = _context11.sent;
              _context11.next = 5;
              return select(function (state) {
                return state.bi1101Info.initPayload;
              });
            case 5:
              initPayload = _context11.sent;
              if (!backData.success) {
                _context11.next = 15;
                break;
              }
              BossMessage(true, "Successfully edited");
              if (payload.init && payload.init.isNotNeed) {
                _context11.next = 11;
                break;
              }
              _context11.next = 11;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 11:
              _context11.next = 13;
              return put({
                type: "get_link_list",
                payload: initPayload
              });
            case 13:
              _context11.next = 16;
              break;
            case 15:
              BossMessage(false, "Editing failed:" + backData.result);
            case 16:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      })();
    },
    create_link_batch: function create_link_batch(_ref23, _ref24) {
      var payload = _ref23.payload;
      var select = _ref24.select,
        call = _ref24.call,
        put = _ref24.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var backData1, backData, initPayload;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return call(_get_link_interface_ip, {
                company_id: payload.update.company_id,
                link_type: payload.update.link_type,
                agency_ids: payload.update.edge_agency_ids.join(',')
              });
            case 2:
              backData1 = _context12.sent;
              _context12.next = 5;
              return call(_create_link_batch, _objectSpread({}, payload.update, {
                interface_ip_list: backData1.data.interface_ip
              }));
            case 5:
              backData = _context12.sent;
              _context12.next = 8;
              return select(function (state) {
                return state.bi1101Info.initPayload;
              });
            case 8:
              initPayload = _context12.sent;
              if (!backData.success) {
                _context12.next = 19;
                break;
              }
              BossMessage(true, "Successfully added");
              _context12.next = 13;
              return call(all_company_update, {
                company_id: payload.update.company_id
              });
            case 13:
              _context12.next = 15;
              return put({
                type: "get_link_list",
                payload: initPayload
              });
            case 15:
              _context12.next = 17;
              return put({
                type: "get_link_stat",
                payload: {
                  is_active: 1
                }
              });
            case 17:
              _context12.next = 20;
              break;
            case 19:
              BossMessage(false, "Add failed:" + backData.result);
            case 20:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      })();
    },
    delete_link: function delete_link(_ref25, _ref26) {
      var payload = _ref25.payload;
      var select = _ref26.select,
        call = _ref26.call,
        put = _ref26.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var backData, initPayload;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return call(_delete_link, payload["delete"]);
            case 2:
              backData = _context13.sent;
              _context13.next = 5;
              return select(function (state) {
                return state.bi1101Info.initPayload;
              });
            case 5:
              initPayload = _context13.sent;
              if (!backData.success) {
                _context13.next = 16;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context13.next = 10;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 10:
              _context13.next = 12;
              return put({
                type: "get_link_list",
                payload: initPayload
              });
            case 12:
              _context13.next = 14;
              return put({
                type: "get_link_stat",
                payload: {
                  is_active: 1
                }
              });
            case 14:
              _context13.next = 17;
              break;
            case 16:
              BossMessage(false, "Delete failed:" + backData.result);
            case 17:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      })();
    },
    delete_link_batch: function delete_link_batch(_ref27, _ref28) {
      var payload = _ref27.payload;
      var select = _ref28.select,
        call = _ref28.call,
        put = _ref28.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var backDataLink, initPayload;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return call(_delete_link, payload["delete"]);
            case 2:
              backDataLink = _context14.sent;
              _context14.next = 5;
              return select(function (state) {
                return state.bi1101Info.initPayload;
              });
            case 5:
              initPayload = _context14.sent;
              if (!backDataLink.success) {
                _context14.next = 14;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context14.next = 10;
              return put({
                type: "get_link_list",
                payload: initPayload
              });
            case 10:
              _context14.next = 12;
              return put({
                type: "get_link_stat",
                payload: {
                  is_active: 1
                }
              });
            case 12:
              _context14.next = 15;
              break;
            case 14:
              BossMessage(false, "Delete failed:" + backDataLink.result);
            case 15:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      })();
    },
    get_link_list_HA_center: function get_link_list_HA_center(_ref29, _ref30) {
      var payload = _ref29.payload;
      var call = _ref30.call,
        put = _ref30.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return call(_get_link_list, payload);
            case 2:
              backData = _context15.sent;
              _context15.next = 5;
              return put({
                type: "update",
                payload: {
                  HALinkList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      })();
    },
    get_link_list_HA_edge: function get_link_list_HA_edge(_ref31, _ref32) {
      var payload = _ref31.payload;
      var call = _ref32.call,
        put = _ref32.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return call(_get_link_list, payload);
            case 2:
              backData = _context16.sent;
              _context16.next = 5;
              return put({
                type: "update",
                payload: {
                  HALinkList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      })();
    },
    set_backup_link: function set_backup_link(_ref33, _ref34) {
      var payload = _ref33.payload;
      var call = _ref34.call,
        put = _ref34.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return call(_set_backup_link, payload.update);
            case 2:
              backData = _context17.sent;
              if (!backData.success) {
                _context17.next = 11;
                break;
              }
              BossMessage(true, "修改成功");
              _context17.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context17.next = 9;
              return put({
                type: "get_link_list",
                payload: payload.init
              });
            case 9:
              _context17.next = 12;
              break;
            case 11:
              BossMessage(false, "Editing failed" + backData.result);
            case 12:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      })();
    },
    update_link_batch: function update_link_batch(_ref35, _ref36) {
      var payload = _ref35.payload;
      var select = _ref36.select,
        call = _ref36.call,
        put = _ref36.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var backData, initPayload;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              delete payload.update.ifEditBandwidth;
              delete payload.update.ifEditGrade;
              _context18.next = 4;
              return call(_update_link_batch, payload.update);
            case 4:
              backData = _context18.sent;
              _context18.next = 7;
              return select(function (state) {
                return state.bi1101Info.initPayload;
              });
            case 7:
              initPayload = _context18.sent;
              if (!backData.success) {
                _context18.next = 16;
                break;
              }
              BossMessage(true, "Successfully edited");
              _context18.next = 12;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 12:
              _context18.next = 14;
              return put({
                type: "get_link_list",
                payload: initPayload
              });
            case 14:
              _context18.next = 17;
              break;
            case 16:
              BossMessage(false, "Editing failed" + backData.result);
            case 17:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      })();
    },
    get_l3_tunnel: function get_l3_tunnel(_ref37, _ref38) {
      var payload = _ref37.payload;
      var call = _ref38.call,
        put = _ref38.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return call(_get_l3_tunnel, payload);
            case 2:
              backData = _context19.sent;
              _context19.next = 5;
              return put({
                type: "update",
                payload: {
                  l3TunnelData: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      })();
    },
    update_l3_tunnel: function update_l3_tunnel(_ref39, _ref40) {
      var payload = _ref39.payload;
      var call = _ref40.call,
        put = _ref40.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return call(_update_l3_tunnel, payload.update);
            case 2:
              backData = _context20.sent;
              if (!backData.success) {
                _context20.next = 9;
                break;
              }
              BossMessage(true, "Successfully edited");
              _context20.next = 7;
              return put({
                type: "get_l3_tunnel",
                payload: payload.init
              });
            case 7:
              _context20.next = 10;
              break;
            case 9:
              BossMessage(false, "Editing failed:" + backData.result);
            case 10:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      })();
    },
    create_l3_tunnel: function create_l3_tunnel(_ref41, _ref42) {
      var payload = _ref41.payload;
      var call = _ref42.call,
        put = _ref42.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return call(_create_l3_tunnel, payload.update);
            case 2:
              backData = _context21.sent;
              if (!backData.success) {
                _context21.next = 9;
                break;
              }
              BossMessage(true, "Successfully added");
              _context21.next = 7;
              return put({
                type: "get_l3_tunnel",
                payload: payload.init
              });
            case 7:
              _context21.next = 10;
              break;
            case 9:
              BossMessage(false, "Add failed:" + backData.result);
            case 10:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      })();
    },
    delete_l3_tunnel: function delete_l3_tunnel(_ref43, _ref44) {
      var payload = _ref43.payload;
      var call = _ref44.call,
        put = _ref44.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return call(_delete_l3_tunnel, payload.update);
            case 2:
              backData = _context22.sent;
              if (!backData.success) {
                _context22.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context22.next = 7;
              return put({
                type: "get_l3_tunnel",
                payload: payload.init
              });
            case 7:
              _context22.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed:" + backData.result);
            case 10:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      })();
    },
    get_ip_groups: function get_ip_groups(_ref45, _ref46) {
      var payload = _ref45.payload;
      var call = _ref46.call,
        put = _ref46.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return call(_get_ip_groups, payload);
            case 2:
              backData = _context23.sent;
              _context23.next = 5;
              return put({
                type: "update",
                payload: {
                  ipGroupData: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      })();
    },
    get_link_interface_ip: function get_link_interface_ip(_ref47, _ref48) {
      var payload = _ref47.payload,
        callback = _ref47.callback;
      var call = _ref48.call,
        put = _ref48.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return call(_get_link_interface_ip, payload);
            case 2:
              backData = _context24.sent;
              if (callback && typeof callback === 'function') {
                callback(backData);
              }
            case 4:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      })();
    },
    query_link_effect: function query_link_effect(_ref49, _ref50) {
      var payload = _ref49.payload,
        callback = _ref49.callback;
      var call = _ref50.call,
        put = _ref50.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var backData, data, i;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return call(_query_link_effect, payload);
            case 2:
              backData = _context25.sent;
              data = [];
              if (backData.retcode === 0) {
                if (backData && backData.data && backData.data.result) {
                  for (i in backData.data.result) {
                    data.push({
                      name: i,
                      data: backData.data.result[i]
                    });
                  }
                }
                if (callback && typeof callback === 'function') {
                  callback(data);
                }
              } else {
                BossMessage(false, backData.msg);
              }
            case 5:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};